import { SiteConfig } from "@/types"

export const siteConfig: SiteConfig = {
  name: "Botbyte AI",
  description:
    "Build smarter AI chatbots, generate websites from prompts, and design visual workflows — powered by Claude, GPT & Gemini. Create, train, and embed multi-model AI on your website in minutes.",
  url: "https://botbyte.in/",
  ogImage: "https://botbyte.in/botbyte-logo.png",
  links: {
    twitter: "https://twitter.com/sarcastic_sb",
    github: "https://github.com/sanketbagad",
    productHunt: "https://www.producthunt.com/posts/botbyte-ai",
    buyMeACoffee: "https://www.buymeacoffee.com/sanketbagad",
    hashnode: "https://sanketbagad.hashnode.dev/",
    devhunt: "https://devhunt.org/tool/bytebot-ai",
    resourceFyi: "https://resource.fyi/products/botbyte-ai",
  },
}
